import React, { forwardRef, useState } from 'react';
import classes from './MAIN.module.scss';
import { ComponentProps } from './MAIN.model';
import { MAINContext } from './MAIN.context';
import MedioLogo from '../../assets/medio_logo.png';
import MedirexLogo from '../../assets/medirex_logo.png';
import LoginCover from '../../assets/cover.svg';
import { MedirexLoginBox } from '../MedirexLoginBox';
import { MedioLoginBox } from '../MedioLoginBox';
import LanguageSwitcher from '../LanguageSwitcher';

//Az app vagy fő komponenst elnevezése.
//TODO: megadni a nevét, de a mappa nevet nem változtatni!!!
function Login(props: ComponentProps, ref: any) {
	const [loginType, setLoginType] = useState<'medio' | 'medirex'>('medio');

	const renderContentBasedOnLoginType: any = () => {
		switch (loginType) {
			case 'medio':
				return {
					backgroundColor: '#3C80CF',
					logoWidth: '344px',
					logoHeight: '160px',
					loginTitle: props.translates ? props.translates.medio_login_title : 'Belépés a Medio felületére',
					logo: MedioLogo,
					cover: LoginCover,
					loginBoxComponent: (
						<MedioLoginBox
							loginTitle={
								props.translates ? props.translates.medio_login_title : 'Belépés a Medio felületére'
							}
							loginType={loginType}
							setLoginType={setLoginType}
							handleMedioLogin={props.handleMedioLogin}
							translates={props.translates}
						/>
					),
				};
			case 'medirex':
				return {
					backgroundColor: '#2F9DF8',
					logoWidth: '344px',
					logoHeight: '160px',
					loginTitle: props.translates
						? props.translates.medirex_login_title
						: 'Belépés a Medirex felületére',
					logo: MedirexLogo,
					cover: LoginCover,
					loginBoxComponent: (
						<MedirexLoginBox
							loginTitle={
								props.translates ? props.translates.medirex_login_title : 'Belépés a Medirex felületére'
							}
							loginType={loginType}
							setLoginType={setLoginType}
							handleMedirexLogin={(state) => {
								if (props.handleMedirexLogin) {
									props.handleMedirexLogin(state);
								}
							}}
							translates={props.translates}
						/>
					),
				};
		}
	};

	return (
		<MAINContext.Provider value="">
			<div className={classes.loginWrapper}>
				<LanguageSwitcher systemLanguages={props.systemLanguages} />
				<div
					className={classes.mobileMenu}
					style={{ background: renderContentBasedOnLoginType().backgroundColor }}
				>
					<img
						className={classes.loginLogo}
						style={{
							width: `calc(${renderContentBasedOnLoginType().logoWidth} / 2)`,
							height: `calc(${renderContentBasedOnLoginType().logoHeight} / 2)`,
						}}
						src={renderContentBasedOnLoginType().logo}
						alt="Logo"
					/>
				</div>
				<div
					className={classes.coverContainer}
					style={{ background: renderContentBasedOnLoginType().backgroundColor }}
				>
					<div className={classes.loginTitleContainer}>
						<h3 className={classes.loginTitle}>{renderContentBasedOnLoginType().loginTitle}</h3>
						<p className={classes.loginDescription}>
							{props.translates
								? props.translates.login_description
								: 'A bejelentkezéshez kérjük válassza ki a platformot, majd adja meg e-mail címét és jelszavát.'}
						</p>
					</div>
					<img
						className={classes.loginLogo}
						style={{
							width: renderContentBasedOnLoginType().logoWidth,
							height: renderContentBasedOnLoginType().logoHeight,
						}}
						src={renderContentBasedOnLoginType().logo}
						alt="Logo"
					/>
					<img className={classes.loginCover} src={renderContentBasedOnLoginType().cover} alt="Logo" />
				</div>
				<div className={classes.loginContainer}>{renderContentBasedOnLoginType().loginBoxComponent}</div>
			</div>
		</MAINContext.Provider>
	);
}

export default forwardRef(Login);
